import { BaseStore } from 'core/base-store';
import { SequenceRepository } from 'core/sequence.repository';
import { catchError, first, from, map, of } from 'rxjs';

import { UiService } from '../../../../core/services/ui.services';
import { CashBook } from './cash-book.model';
import CashBookRepository from './cash-book.repository';

const itemInit: CashBook = new CashBook('');
type IState = {
  transactions: CashBook[];
};
const stateInit: IState = {
  transactions: [],
};

export class CashBookStore extends BaseStore<IState, CashBook> {
  get sequenceName() {
    return this.repository.collectionName + '-transactionCode';
  }
  seed = 1;
  constructor(
    uiService: UiService,
    private sequence: SequenceRepository,
    private repository: CashBookRepository,
  ) {
    super(uiService, stateInit, itemInit);
  }

  loadList() {
    this.ui.loader.show();
    from(this.repository.getAllOrderTransactionCode())
      .pipe(
        catchError(() => of([] as CashBook[])),
        map(transactions => {
          this._state.next({ transactions });
          this.ui.loader.hide();
        }),
        first(),
      )
      .subscribe();
  }

  async save() {
    try {
      const model = this.current;
      const entity = CashBook.build(model);
      if (!entity.id) {
        entity.transactionCode = await this.sequence.next(this.sequenceName, this.seed);
        await this.repository.add(entity);
      } else {
        if (!entity.transactionCode)
          entity.transactionCode = await this.sequence.next(this.sequenceName, this.seed);
        await this.repository.update(entity.id, entity);
      }
      this.ui.modal.close();
      this.loadList();
    } catch (e: any) {
      this.showValidationMessage(e.message);
    }
  }

  delete(id: string) {
    this.repository.delete(id);
    this.loadList();
  }
}
